import { BulkCreateContentPackagesMeta, BulkCreateContentPackagesPayload } from 'types/store/BulkCreateContentPackages';
import { createAsyncReducer } from 'utils/Redux';

import { bulkCreateContentPackagesActions } from '../actions';

export default createAsyncReducer<BulkCreateContentPackagesMeta, BulkCreateContentPackagesPayload>(bulkCreateContentPackagesActions);
